import React, {Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import history from '../../util/history'
import { selectIsRequestPending } from '../../util'
import { Spinner, H3 } from '../../components/index'

import { setRequestType, clearNewIssueKey, getAllRequestTypes } from '../actions'
import { selectRequestTypes } from '../reducer'


//.unshift can be used to add an element to the begining of an array. rows is an array

export class RequestTypeList extends Component {
    componentWillMount () {
      let { getAllRequestTypes } = this.props
      getAllRequestTypes()
    }
    render () {
        let { requestTypes, setRequestType, clearNewIssueKey, isSelectRequestTypesPending } = this.props
        let rows = null
        if (requestTypes.length > 0 && !isSelectRequestTypesPending) {
          rows = requestTypes.map(requestType => {
            return (
                <tr className='u-cursor-pointer' key={requestType.name} onClick={() => {
                   setRequestType(requestType); clearNewIssueKey(); history.push(`/createReq`)}}>
                    <td>{requestType.title}</td>
                    <td>{requestType.description}</td>
                </tr>

            )
          })
        }
        
        let accessRequest = (
          <tr className='u-cursor-pointer' key='Access Request' onClick={() => {history.push('/')}}>
            <td>Access Request</td>
            <td>Select for help gaining access to Jira, Portfolio for Jira Sidebar, Confluence, Bitbucket, or Github</td>
          </tr>
        )
        if (rows) { rows.unshift(accessRequest)}

        return (
          <div>
            {
              requestTypes.length > 0 && !isSelectRequestTypesPending ?
                <div>
                  <H3 className='pb5-sm'>Create Request</H3>
                  <div>
                    <table className='page-table'>
                      <thead className='u-uppercase u-bold'>
                        <tr>
                          <th>Name</th>
                          <th>Description</th>                    
                        </tr>
                      </thead>
                      <tbody>
                        {rows}
                      </tbody>                
                    </table>
                  </div> 
                </div>
                : 
                  <div>  
                    <H3 className='pb5-sm'>Create Request</H3>
                    <Spinner medium />
                  </div>
            }
          </div>
          )
    }
}

export default withRouter(connect((state) => {
  return {
    isSelectRequestTypesPending: selectIsRequestPending(state, getAllRequestTypes),
    requestTypes: selectRequestTypes(state)
  }
}, { setRequestType, clearNewIssueKey, getAllRequestTypes }) (RequestTypeList))



// WEBPACK FOOTER //
// ./client/src/serviceDesk/request/RequestTypeList.js